<template>

  <div class="d-flex justify-center align-center flex-column">

    <div class="container-head" v-html="$t('Home.HeadHome.head')"></div>

    <div class="text-center mt-3">
      <v-btn
        rounded
        class="font-weight-light text-capitalize btn-text"
        @click="analyticSignUp"
        color="purple darken-4"
        dark
      >
        <a
          href="/signup"
          class="white--text"
          v-html="$t('Home.HeadHome.btnHead')"
          style="font-family: Open Sans; text-decoration: none;font-size:16px;"
        ></a>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
export default {
   methods: {
    analyticSignUp() {
      analytics.logEvent("Sig_HeadHome");
    },
  },
};
</script>

<style>
.container-head {
  margin-top: 70px;
  width: 70%;
  height: 20%;
  text-align: center;
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
}

.btn-text {
  font-size: 18px !important;
}
</style>